import { notification } from "antd";
import { BASE_API_URL } from "../../shared/constants";

export const _BASE_URL = BASE_API_URL;
const displayError = (message: any, shouldHide: any) => {
  !shouldHide && notification.error({ message: message });
};

export async function Client(
  endpoint: string,
  { body, ...customConfig } = {} as any
) {
  const headers: any = { "Content-Type": "application/json", version: "0.0.1" };

  if (localStorage.getItem("token")) {
    headers["Authorization"] = `Bearer ${localStorage.getItem("token")}`;
  }
  if (localStorage.getItem("account_id")) {
    headers["account_id"] = localStorage.getItem("account_id");
  }
  if (localStorage.getItem("auth-type")) {
    headers["auth-type"] = localStorage.getItem("auth-type");
  }
  if (localStorage.getItem("application_id")) {
    headers["application_id"] = localStorage.getItem("application_id");
  }
  let application_slug;
  if (localStorage.getItem("application_slug")) {
    application_slug = localStorage.getItem("application_slug");
  }
  const config = {
    method: body ? "POST" : "GET",
    ...customConfig,
    headers: {
      ...headers,
      ...customConfig.headers,
    },
  };
  if (body) {
    config.body = JSON.stringify(body);
  }

  let data;
  const BASE_URL = _BASE_URL;
  try {
    const response = await window.fetch(BASE_URL + endpoint, config);

    if (response.ok) {
      if (response.status === 204) {
        return {
          status: response.status,
          headers: response.headers,
          url: response.url,
        };
      }
      data = await response.json();
      // Return a result object similar to Axios
      return {
        status: response.status,
        data,
        headers: response.headers,
        url: response.url,
      };
    } else if (response.status === 401) {
      displayError("Un Authorized", customConfig?.shouldHide);
      window.localStorage.clear();
      window.location.href = "/";
    } else if (response.status === 403) {
      data = await response.json();
      displayError(data.message || "Forbidden", customConfig?.shouldHide);
      return Promise.reject(data.message || "Forbidden");
    } else if (response.status === 400 || response.status === 404) {
      data = await response.json();
      let message = data.message;
      if (data.errorDetails) {
        message = data.errorDetails
          .map((e: any) => `${e.message || e.error}`)
          .join(", ");
      }
      displayError(message || "Forbidden", customConfig?.shouldHide);
      return Promise.reject(message);
    }
    displayError(
      response.statusText || "Something went wrong",
      customConfig?.shouldHide
    );
    return Promise.reject(response.statusText);
  } catch (err: any) {
    //   notification.error({ message: err.message ? err.message : data });
    notification.error({ message: "Please check your internet connection" });
    return Promise.reject(err.message ? err.message : data);
  }
}

Client.get = function (endpoint: string, customConfig: any = {}) {
  
  if (customConfig.params) {
    return Client(paramsEndpoint(endpoint, customConfig), {
      ...customConfig,
      method: "GET",
    });
  } else {
    delete customConfig.params;
    return Client(endpoint, { ...customConfig, method: "GET" });
  }
};

Client.post = function (endpoint: string, body: any, customConfig = {}) {
  return Client(paramsEndpoint(endpoint, customConfig), { ...customConfig, body, method: "POST" });
};

Client.put = function (endpoint: string, body: any, customConfig = {}) {
  return Client(paramsEndpoint(endpoint, customConfig), { ...customConfig, body, method: "PUT" });
};

Client.patch = function (endpoint: string, body: any, customConfig = {}) {
  return Client(paramsEndpoint(endpoint, customConfig), { ...customConfig, body, method: "PATCH" });
};

Client.delete = function (endpoint: string, customConfig = {}) {
  return Client(paramsEndpoint(endpoint, customConfig), { ...customConfig, method: "DELETE" });
};

const paramsEndpoint = (endpoint:string, customConfig:any) => {
  let params: any = [];
  if (customConfig.params) {
    for (let p in customConfig.params) {
      let key = p;
      if (Array.isArray(customConfig.params[p])) {
        customConfig.params[p].forEach((element: any) => {
          params.push(`${key}=${encodeURIComponent(element)}`);
        });
      } else {
        params.push(`${key}=${encodeURIComponent(customConfig.params[p])}`);
      }
    }
  }
  return endpoint + "?" + params.join("&");
}